import { render } from "./LicenseDialog.vue?vue&type=template&id=5171e7ac&scoped=true"
import script from "./LicenseDialog.vue?vue&type=script&lang=js"
export * from "./LicenseDialog.vue?vue&type=script&lang=js"

import "./LicenseDialog.vue?vue&type=style&index=0&id=5171e7ac&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5171e7ac"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QCardActions,QBtn});qInstall(script, 'directives', {ClosePopup});
